import counterUp from 'counterup2'

// Logic for intersection observer to init counterUp on scroll
const callback = entries => {
    entries.forEach(entry => {
        const el = entry.target
        if (entry.isIntersecting) {
            counterUp(el, {
                duration: 2000, // Duration of animation
                delay: 16, // Animation delay
            })
        }
    })
}

// Init intersection observer for counterUp el
const IO = new IntersectionObserver(callback, {threshold: 1})
const el = document.querySelectorAll('.counter-number');
el.forEach(el => {
    IO.observe(el);
})
